import fetch from 'node-fetch';

/*
 * Ambil timpaan teks situs publik dari dashboard.
 *
 * Pola URL-nya sama persis dengan fetchStaticPage: relatif di browser, loopback
 * di server — supaya tidak bisa rusak oleh SITE_URL di .env (lihat komentar di
 * fetchStaticPage.js untuk kenapa itu penting).
 *
 * Bedanya, ini dipanggil di SETIAP halaman publik, jadi ada cache proses
 * berumur pendek. Tanpa itu setiap kunjungan menambah satu roundtrip GraphQL ke
 * diri sendiri hanya untuk membaca tabel yang berubah beberapa kali setahun.
 *
 * ponytail: cache per-proses, TTL 60 detik. Tanpa invalidasi lintas proses —
 * kalau pm2 dijalankan cluster, dua worker bisa berbeda selama satu menit
 * setelah client menekan Save. Kalau itu jadi masalah, pindahkan ke cache
 * bersama (redis) atau bust lewat updateSiteCopy.
 */
const TTL = 60 * 1000;
let cache = { at: 0, data: {} };

const QUERY = `{ getSiteCopy { results { key en ar } } }`;

const selfUrl = () => (typeof window === 'undefined'
  ? `http://127.0.0.1:${process.env.PORT || 3000}/graphql`
  : '/graphql');

export default async function fetchSiteCopy() {
  if (Date.now() - cache.at < TTL) return cache.data;

  try {
    const resp = await fetch(selfUrl(), {
      method: 'post',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: QUERY })
    });
    const { data } = await resp.json();
    const rows = (data && data.getSiteCopy && data.getSiteCopy.results) || [];

    // Bentuk { 'en-US': {key: value}, ar: {...} } supaya t() bisa memakainya
    // dengan lookup yang sama seperti copy.json — nilai kosong dibuang di sini,
    // jadi t() tidak perlu tahu bedanya "belum diisi" dan "sengaja kosong".
    const data2 = { 'en-US': {}, ar: {} };
    rows.forEach(r => {
      if (r.en) data2['en-US'][r.key] = r.en;
      if (r.ar) data2.ar[r.key] = r.ar;
    });

    cache = { at: Date.now(), data: data2 };
    return data2;
  } catch (e) {
    // Situs tampil dengan teks bawaan lebih baik daripada 500. Cache juga
    // hasil gagal, kalau tidak setiap request akan mencoba ulang dan menunggu
    // timeout yang sama.
    cache = { at: Date.now(), data: {} };
    return {};
  }
}
